module.exports = __webpack_public_path__ + "static/media/what-are-healthy-lifestyle.72d15e18.png";